import { compareObjects } from "@/utils/CompareObjects";
import { getNestedObject } from "@/utils/GetNestedObject";
import { parseStringToFloatDoubleFixed } from "@/utils/ParseStringToFloatDoubleFixed";

function additionalIsPersonalized(additionalContractItems) {
  for (const additional of additionalContractItems) {
    const additionalContractItem = {
      bonus: Number(additional?.bonusOverride).toFixed(2),
      activationValue: parseStringToFloatDoubleFixed(
        additional?.activationValueOverride?.toString()
      ),
      monthlyFee: parseStringToFloatDoubleFixed(
        additional?.monthlyFeeOverride?.toString()
      )
    };

    const additionalOfferPrice = {
      bonus: Number(additional.additionalOfferPrice?.bonus).toFixed(2),
      activationValue: parseStringToFloatDoubleFixed(
        additional.additionalOfferPrice?.activationValue?.toString()
      ),
      monthlyFee: parseStringToFloatDoubleFixed(
        additional.additionalOfferPrice?.monthlyFee?.toString()
      )
    };

    const additionalIsEqual = compareObjects(
      additionalContractItem,
      additionalOfferPrice
    );

    if (!additionalIsEqual) {
      return true;
    }
  }

  return false;
}

export const checkCustomBenefits = item =>
  (item.offerOverride &&
    Object.entries(item.offerOverride).length &&
    !(
      Object.entries(item.offerOverride).length === 1 &&
      item.offerOverride?.sim === "0"
    )) ||
  (item?.additionalContractItems &&
    additionalIsPersonalized(item.additionalContractItems));

export function phoneNumberFormat(number: string) {
  return number.replace(/(\d{2})(\d{5})/, "($1) $2-");
}

export function copyAndSortProducts<T>(
  items: T[],
  columnKey: string,
  isSortedDescending?: boolean
): T[] {
  const properties = columnKey.split("|");

  return items.slice(0).sort((a: T, b: T) => {
    let valueA;
    let valueB;

    if (properties.length > 1) {
      const termA = properties.find(prop =>
        getNestedObject(a as any, prop.split("."))
      );

      const termB = properties.find(prop =>
        getNestedObject(b as any, prop.split("."))
      );

      termA && (valueA = getNestedObject(a as any, termA.split(".")));
      termB && (valueB = getNestedObject(b as any, termB.split(".")));
    } else {
      valueA = getNestedObject(a as any, columnKey.split("."));
      valueB = getNestedObject(b as any, columnKey.split("."));
    }

    valueA = isNaN(valueA) ? valueA : Number(valueA);
    valueB = isNaN(valueB) ? valueB : Number(valueB);

    return (isSortedDescending ? valueA < valueB : valueA > valueB) ? 1 : -1;
  });
}
